import { Dialog, dialogClasses } from '@ori-ui/components';
import { styled } from '@ori-ui/mui';

export const SharingPopup = styled(Dialog)<{
  ownerState: { isCopyLinkOpen: boolean };
}>(({ ownerState: { isCopyLinkOpen }, theme }) => ({
  ...(isCopyLinkOpen && {
    [`&.${dialogClasses.header}`]: {
      paddingBottom: theme.spacing(6),
    },
    [`&.${dialogClasses.content}`]: {
      maxWidth: 540,
    },
  }),
}));
